import React, {createContext, useCallback, useContext, useMemo} from "react";
import {useAuth} from "../auth-context";
import {PermissionsContextData} from "./types";
import {JwtUserClaim} from "../../models/account/jwt-payload";
import {Profile} from "../../models/account/user";

export const PermissionsContext = createContext<PermissionsContextData>({} as PermissionsContextData);

export const usePermissionsContext = () => useContext(PermissionsContext);

export const PermissionsProvider = ({children}: { children: React.ReactNode }) => {
    const {user: authUser} = useAuth();

    const user = (authUser as JwtUserClaim | null) ?? null;
    const perfil = user?.perfil ?? null;
    const isSuperuser = !!user?.is_superuser;

    const hasPermission = useCallback((allowed: (Profile | string)[]) => {
        if (!perfil) {
            return false;
        }
        return allowed.includes(perfil);
    }, [perfil]);

    const value = useMemo<PermissionsContextData>(() => ({
        user,
        isSuperuser,
        perfil,
        hasPermission,
    }), [user, isSuperuser, perfil, hasPermission]);

    return (
        <PermissionsContext.Provider value={value}>
            {children}
        </PermissionsContext.Provider>
    );
};
